import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError, BaseResponseEntities } from 'app/shared/reducers/reducer.utils';
import { IReportCompliance, IReportSchedule } from 'app/shared/model/report-schedule.model';
import { apiOkr } from 'app/config/axios-interceptor';

const initialState: EntityState<IReportSchedule> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: null,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/okr';

// Actions
export const exportExcelReportCompliance = createAsyncThunk(
  'reportCompliance/export_excel_report_compliance',
  async ({ reportScheduleId }: any) => {
    const result = await apiOkr.get<any>(`${apiUrl}/report/compliance?reportScheduleId=${reportScheduleId}`, {
      responseType: 'blob', // Set responseType to 'blob' for binary data
    timeout: 120000,
  });
  return result;
}, { serializeError: serializeAxiosError });

// slice

export const ReportComplianceSlice = createEntitySlice({
  name: 'reportCompliance',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(exportExcelReportCompliance.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = action.payload.data as IReportCompliance[];
      })
      .addCase(exportExcelReportCompliance.pending, (state, action) => {
        state.loading = true;
        state.errorMessage = null;
        state.updateSuccess = false;
      })
      .addCase(exportExcelReportCompliance.rejected, (state, action) => {
        state.loading = true;
        state.errorMessage = action.error.message;
        state.updateSuccess = false;
      })
  },
});

export const { reset: resetReportCompliance } = ReportComplianceSlice.actions;

// Reducer
export default ReportComplianceSlice.reducer;
